import { useState } from 'react';
import { supabase } from '../../supabaseClient';

const IconHeart = ({ filled }) => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

function tempoRelativo(dateStr) {
  const diff = Math.floor((Date.now() - new Date(dateStr)) / 1000);
  if (diff < 60) return 'agora mesmo';
  if (diff < 3600) return `há ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `há ${Math.floor(diff / 3600)}h`;
  const dias = Math.floor(diff / 86400);
  return `há ${dias} dia${dias > 1 ? 's' : ''}`;
}

export default function CardReflexao({ reflexao, userId, jaMeIdentifiquei, onIdentificou }) {
  const [identificado, setIdentificado] = useState(jaMeIdentifiquei);
  const [count, setCount] = useState(reflexao.me_identifico_count || 0);
  const [carregando, setCarregando] = useState(false);

  const handleMeIdentificar = async () => {
    if (identificado || carregando || !userId) return;
    setCarregando(true);
    try {
      const { error } = await supabase.from('me_identifico').insert([{
        reflexao_id: reflexao.id,
        user_id: userId,
      }]);

      if (!error) {
        await supabase.rpc('incrementar_me_identifico', { p_reflexao_id: reflexao.id });
        setIdentificado(true);
        setCount(c => c + 1);
        if (onIdentificou) onIdentificou(reflexao.id);
      }
    } catch {
      // unique constraint = já clicou
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="card-reflexao">
      <p className="card-reflexao-tempo">{tempoRelativo(reflexao.created_at)}</p>
      {reflexao.desafio_dia && (
        <p className="card-reflexao-desafio">
          Dia {reflexao.desafio_dia}
          {reflexao.desafio_nome ? ` · ${reflexao.desafio_nome}` : ''}
        </p>
      )}
      {reflexao.prompt && (
        <p className="card-reflexao-prompt">{reflexao.prompt}</p>
      )}
      <p className="card-reflexao-texto">"{reflexao.texto}"</p>
      <div className="card-reflexao-rodape">
        {count > 0 && (
          <span className="card-reflexao-count">
            <IconHeart filled />
            {count} {count === 1 ? 'pessoa se identificou' : 'pessoas se identificaram'}
          </span>
        )}
        <button
          className={`btn card-reflexao-btn${identificado ? ' identificado' : ''}`}
          onClick={handleMeIdentificar}
          disabled={identificado || carregando || !userId}
        >
          <IconHeart filled={identificado} />
          {identificado ? 'Você se identificou' : 'Me identifico'}
        </button>
      </div>
    </div>
  );
}
